// src/services/propiedadAdjuntosService.js
import { db } from '../Firebase/firebaseconfig';
import {
  collection, addDoc, serverTimestamp, deleteDoc, doc, onSnapshot, query, orderBy
} from 'firebase/firestore';
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';

const pathAdjuntosCol = (propiedadId) => collection(db, 'propiedades', propiedadId, 'adjuntos');

export function listenAdjuntosPropiedad(propiedadId, cb) {
  const q = query(pathAdjuntosCol(propiedadId), orderBy('createdAt', 'desc'));
  return onSnapshot(q, (snap) => {
    cb(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  });
}

/**
 * Sube un archivo a Storage y crea un doc en subcolección
 * @param {*} propiedadId
 * @param {*} file File
 * @param {*} extra { uid, notas }
 * @param {*} onProgress (0..100)
 * @returns metadata del adjunto
 */
export async function uploadAdjuntoPropiedad(propiedadId, file, { uid, notas }, onProgress) {
  const storage = getStorage();
  const storagePath = `propiedades/${propiedadId}/adjuntos/${Date.now()}-${file.name}`;
  const storageRef = ref(storage, storagePath);

  const task = uploadBytesResumable(storageRef, file);
  await new Promise((resolve, reject) => {
    task.on('state_changed', (snap) => {
      const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
      onProgress?.(pct);
    }, reject, resolve);
  });

  const url = await getDownloadURL(task.snapshot.ref);

  const meta = {
    nombre: file.name,
    tipo: file.type || '',
    size: file.size || 0,
    url,
    storagePath,
    createdAt: serverTimestamp(),
    createdBy: uid || null,
    notas: notas || ''
  };

  const col = pathAdjuntosCol(propiedadId);
  const refDoc = await addDoc(col, meta);
  return { id: refDoc.id, ...meta };
}

export async function deleteAdjuntoPropiedad(propiedadId, adjuntoId, storagePath) {
  const storage = getStorage();
  // Borrar en Storage (si hay path)
  if (storagePath) {
    try {
      await deleteObject(ref(storage, storagePath));
    } catch (e) {
      // si no existe en storage, continuamos con borrar el doc
      console.warn('No se pudo borrar en Storage:', e?.message);
    }
  }
  // Borrar doc
  await deleteDoc(doc(db, 'propiedades', propiedadId, 'adjuntos', adjuntoId));
}
